import css from "../../utils/css";
import allTokens from "../tokens";
var getCssVariables = function getCssVariables(tokens, variant) {
  return Object.keys(tokens).reduce(function (acc, key) {
    if (key === "variant" && variant) {
      var variantVariables = tokens[key][variant];
      var _variables = css.toVariable(variantVariables);
      return Object.assign({}, acc, _variables);
    }
    var variables = css.toVariable(tokens[key]);
    return Object.assign({}, acc, variables);
  }, {});
};
export var getTokens = function getTokens(_ref) {
  var app = _ref.app,
    variant = _ref.variant;
  var tokens = allTokens[app];
  return getCssVariables(tokens, variant);
};
var configureTokens = function configureTokens(_ref2) {
  var app = _ref2.app,
    variant = _ref2.variant;
  var cssVariables = getTokens({
    app: app,
    variant: variant
  });
  css.addVariablesInBody(cssVariables);
  return Promise.resolve();
};
export default configureTokens;